import { BlogPost } from '@/types/blog';

export const post: BlogPost = {
  slug: "fordje-selected-for-laci-incubation-cohort",
  title: "Fordje Selected for LACI's 10th Incubation Cohort to Accelerate Clean Energy Deployment",
  excerpt: "The regulatory data startup joins Los Angeles Cleantech Incubator's flagship program to support faster, more scalable clean energy projects.",
  content: `
    <p>
      <strong>FOR IMMEDIATE RELEASE</strong>
    </p>
    
    <p>
      <strong>LOS ANGELES, CA - June 17, 2025</strong> - Fordje, the AI-powered platform delivering instant, actionable city code data, has been <a href="https://laincubator.org/laci-welcomes-16-new-startups-to-incubation-cohort-10-spring-2025/" class="text-fordje-blue hover:text-fordje-accent underline" target="_blank" rel="noopener noreferrer">selected to join</a> the 10th Incubation Cohort at the <a href="https://laincubator.org" class="text-fordje-blue hover:text-fordje-accent underline" target="_blank" rel="noopener noreferrer">Los Angeles Cleantech Incubator (LACI)</a>. The company will participate in the clean energy track, working alongside fellow startups such as <a href="https://clear-way.ai/" class="text-fordje-blue hover:text-fordje-accent underline" target="_blank" rel="noopener noreferrer">ClearWay Software</a> and <a href="https://nanodc.energy" class="text-fordje-blue hover:text-fordje-accent underline" target="_blank" rel="noopener noreferrer">NanoDC</a> to accelerate deployment of climate-critical infrastructure.
    </p>
    
    <p>
      Each year, LACI selects a cohort of high-potential climate tech companies for its flagship incubation program, providing founders with hands-on mentorship, access to funders and policymakers, and a pathway to scale in the Los Angeles region and beyond.
    </p>
    
    <p>
      "Code confusion causes delays - and delays are expensive," said Gillian Sowray, CEO and co-founder of Fordje. "Over 11% of construction costs in the U.S. - $238 billion a year - are lost to issues tied to unclear or misaligned city codes. We built Fordje to make that data clear and accessible from day one."
    </p>
    
    <p>
      Fordje's platform supports clean energy developers by structuring building, zoning, fire, and climate overlay data across 28,000 U.S. jurisdictions. Its technology ladders code across local, county, state, and I-Code levels, helping project teams avoid rework, eliminate uncertainty, and move faster across multiple markets.
    </p>
    
    <p>
      In addition to clean energy, Fordje's platform can support broader resilience efforts. As Los Angeles rebuilds from recent wildfires and works to address urgent housing needs, Fordje's data tools can help align code requirements with on-the-ground execution - and serve as a resource for local governments shaping more responsive policy.
    </p>
    
    <p>
      "We're honored to join a cohort full of driven, visionary founders," Sowray added. "With LACI's support, we're ready to grow - and help others build smarter and faster, too."
    </p>
    
    <h2>About Fordje</h2>
    
    <p>
      Fordje is an AI-powered platform that makes city codes instantly accessible and actionable for construction and clean tech teams. By delivering accurate regulatory data across all U.S. municipalities, Fordje helps developers avoid costly delays and accelerate deployment of housing, commercial buildings and climate infrastructure. Learn more at <a href="https://www.fordje.com" class="text-fordje-blue hover:text-fordje-accent underline">fordje.com</a>.
    </p>
  `,
  coverImage: "/lovable-uploads/a4fc380d-67b1-4ded-bd35-eb2df92661da.png",
  date: "2025-06-17T12:00:00",
  readTime: 3,
  categories: ["Company News", "Clean Tech", "LACI"],
  author: {
    name: "The Fordje Team",
    title: "Team",
    avatar: "/lovable-uploads/d16c70d8-12ee-4d98-af25-9165e45273e0.png"
  }
};
